module.exports = function() {
  return new Worker(__webpack_public_path__ + "9e91d63ad93c3be785bb.worker.js");
};